export enum RefillFrequency {
  Recurring = 'recurring',
  OneTime = 'one-time',
}

export enum KitType {
  Medication = 'Medication',
  Device = 'Device',
}

export enum Expiration {
  Expired = 'Expired',
  Expiring = 'Expiring',
  Expires = 'Expires',
}

export enum ExpirationTime {
  Yesterday = 'yesterday',
  Today = 'today',
  Tomorrow = 'tomorrow',
}

export enum ItemType {
  Device = 'devices',
  Medication = 'medications',
}

export enum KitItemTooltip {
  discontinued = 'Item is Discontinued',
  refillOn = 'Automatic Refill On',
  refillOff = 'Not on Refill',
}

export enum KitRefillStatus {
  discontinued = 'discontinued',
  refillOn = 'refill-on',
  refillOff = 'refill-off',
}
